module.exports = __webpack_public_path__ + "img/vaticancity.e3e23e2d.svg";